import React from 'react';
import Image from 'components/image/image';
import ContentScroller from 'components/content-scroller/content-scroller';
import './block-text-content-scroll.sass';

const BlockTextContentScroll = ({ data }) => {
  const md = data.content[0];
  const content = data.content[1];
  const content_subtitle = data.content[2];

  return (
    <section className="BlockComparisonTable container-fluid container-fluid--small mt-5">
      <div className="d-flex">
        <div dangerouslySetInnerHTML={{ __html: md}} className="w-50"/>

        <div className="w-50 ml-3">
          <ContentScroller height="600px">
            {content.includes('content/') ? <Image image_url={content} className="w-100"/> : <div className="border-none" dangerouslySetInnerHTML={{ __html: content }} />}
          </ContentScroller>
          <p className="text-center">{content_subtitle}</p>
        </div>
      </div>
    </section>
  )
}

export default BlockTextContentScroll
